"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _ResourcePortal = _interopRequireWildcard(require("../ResourcePortal"));
var _TabIcon = _interopRequireDefault(require("./TabIcon"));
var _defaultIcons = _interopRequireDefault(require("./defaultIcons.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;

// Tabs for resource portals within the resource center
// e.x. Training, Software Help, etc. Resources under a tab have a tag associated with the tab.
var ResourceTabs = /*#__PURE__*/function (_React$Component) {
  function ResourceTabs() {
    var _this;
    _classCallCheck(this, ResourceTabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ResourceTabs, [].concat(args));
    _defineProperty(_this, "state", {
      currentTabTag: _this.props.initialTab || _this.props.tabs[0].tag
    });
    _defineProperty(_this, "resourcePortalRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "setActiveTab", function (e, tag) {
      var _this$props$match, _this$props$match$par;
      e && e.preventDefault();
      _this.resourcePortalRef.current.clearFilters();
      _this.setState({
        currentTabTag: tag
      });

      // only add tab to query string if tab is not already in match params
      if (!((_this$props$match = _this.props.match) !== null && _this$props$match !== void 0 && (_this$props$match$par = _this$props$match.params) !== null && _this$props$match$par !== void 0 && _this$props$match$par.tab)) {
        _this.props.history.push("".concat(_this.props.location.pathname, "?tab=").concat(tag));
      }
    });
    _defineProperty(_this, "componentDidUpdate", function (prevProps, prevState) {
      if (prevProps.tabs !== _this.props.tabs) {
        if (_this.props.initialTab) {
          _this.setState({
            currentTabTag: _this.props.initialTab
          });
        } else {
          _this.setState({
            currentTabTag: _this.props.tabs[0].tag
          });
        }
      }
    });
    _defineProperty(_this, "hasCustomStyles", function (attribute) {
      var hasStyles = _this.props.displayOptions && _this.props.displayOptions.portal;
      return hasStyles && _this.props.displayOptions.portal[attribute];
    });
    _defineProperty(_this, "setTabBarStyle", function () {
      var _this$props = _this.props,
        displayOptions = _this$props.displayOptions,
        showTabs = _this$props.showTabs;
      var textColor;
      var borderColor;
      var backgroundColor;
      var display;
      if (_this.hasCustomStyles('tabTextColor')) {
        textColor = displayOptions.portal.tabTextColor;
      }
      if (_this.hasCustomStyles('tabInactiveColor')) {
        backgroundColor = displayOptions.portal.tabInactiveColor;
      }
      if (_this.hasCustomStyles('tabActiveColor')) {
        borderColor = displayOptions.portal.tabActiveColor;
      }
      if (showTabs === false) {
        display = 'none';
      }
      return {
        color: textColor,
        borderColor: borderColor,
        backgroundColor: backgroundColor,
        display: display
      };
    });
    _defineProperty(_this, "setTabStyle", function (tag) {
      var _this$props2 = _this.props,
        displayOptions = _this$props2.displayOptions,
        tabs = _this$props2.tabs;
      var backgroundColor;
      var textColor;
      var tabFlexBasis = 100 / tabs.length + '%';
      if (_this.hasCustomStyles('tabInactiveColor')) {
        backgroundColor = displayOptions.portal.tabInactiveColor;
      }
      if (tag === _this.state.currentTabTag && _this.hasCustomStyles('tabActiveColor')) {
        backgroundColor = displayOptions.portal.tabActiveColor;
      }
      if (_this.hasCustomStyles('tabTextColor')) {
        textColor = displayOptions.portal.tabTextColor;
      }
      if (tag === _this.state.currentTabTag && _this.hasCustomStyles('tabTextActiveColor')) {
        textColor = displayOptions.portal.tabTextActiveColor;
      }
      return {
        backgroundColor: backgroundColor,
        color: textColor,
        flex: "0 0 ".concat(tabFlexBasis)
      };
    });
    return _this;
  }
  _inherits(ResourceTabs, _React$Component);
  return _createClass(ResourceTabs, [{
    key: "render",
    value: function render() {
      var _displayOptions$resou,
        _this2 = this;
      var _this$props3 = this.props,
        tabs = _this$props3.tabs,
        displayOptions = _this$props3.displayOptions,
        renderResourceTiles = _this$props3.renderResourceTiles;
      var currentTabTag = this.state.currentTabTag;
      var currentTab = this.props.tabs.find(function (item) {
        return item.tag === currentTabTag;
      });
      var filterGroupsToUse = _toConsumableArray(currentTab.filterGroups); // deep copy so it doesn't modify Appdefs form when editing
      if (displayOptions !== null && displayOptions !== void 0 && (_displayOptions$resou = displayOptions.resources) !== null && _displayOptions$resou !== void 0 && _displayOptions$resou.showFavoriteIcon) {
        if (!filterGroupsToUse.some(function (fg) {
          return fg.id === _ResourcePortal.FAVORITES_FILTER_GROUP_KEY;
        })) {
          var lastFg = currentTab.filterGroups.length > 0 ? currentTab.filterGroups[currentTab.filterGroups.length - 1] : {
            collapsible: true,
            isCollapsed: false
          };
          filterGroupsToUse.push({
            id: _ResourcePortal.FAVORITES_FILTER_GROUP_KEY,
            name: 'Favorites',
            collapsible: lastFg.collapsible,
            isCollapsed: lastFg.isCollapsed,
            tags: [_ResourcePortal.FAVORITES_FILTER_GROUP_KEY],
            icon: 'heart'
          });
        }
      }
      if (currentTab) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].tabs,
          style: this.setTabBarStyle()
        }, tabs.map(function (tab) {
          var icons = AppDefs.resourceCenters.icons || _defaultIcons["default"];
          var tabIcon = icons.find(function (icon) {
            return icon.id === tab.icon;
          });
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: tab.tag,
            role: "presentation",
            className: currentTabTag === tab.tag ? _style["default"].active : '',
            onClick: function onClick(e) {
              return _this2.setActiveTab(e, tab.tag);
            },
            style: _this2.setTabStyle(tab.tag)
          }, tabIcon && tab.icon !== 'none' && /*#__PURE__*/_react["default"].createElement(_TabIcon["default"], {
            icon: tabIcon
          }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: tab.label
          })));
        })), /*#__PURE__*/_react["default"].createElement(_ResourcePortal["default"], {
          addToCollection: this.props.addToCollection,
          collection: this.props.collection,
          currentTab: currentTabTag,
          displayOptions: displayOptions,
          filterGroups: filterGroupsToUse,
          id: this.props.id,
          ref: this.resourcePortalRef,
          removeFromCollection: this.props.removeFromCollection,
          addToCollectionButtonLabel: this.props.addToCollectionButtonLabel,
          renderResourceTiles: renderResourceTiles,
          showTabs: this.props.showTabs,
          tags: this.props.tags,
          topFilterBar: currentTab.topFilterBar,
          preventLayoutChange: this.props.preventLayoutChange
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(ResourceTabs, "propTypes", {
  id: _propTypes["default"].string,
  tags: _propTypes["default"].array,
  tabs: _propTypes["default"].array,
  initialTab: _propTypes["default"].string,
  displayOptions: _propTypes["default"].object,
  showTabs: _propTypes["default"].bool,
  renderResourceTiles: _propTypes["default"].func,
  collection: _propTypes["default"].array,
  addToCollection: _propTypes["default"].func,
  removeFromCollection: _propTypes["default"].func,
  addToCollectionButtonLabel: _propTypes["default"].string,
  preventLayoutChange: _propTypes["default"].bool,
  /* From withRouter */
  history: _propTypes["default"].object,
  location: _propTypes["default"].object,
  match: _propTypes["default"].object
});
var _default = exports["default"] = (0, _cccisdReactRouter.withRouter)(ResourceTabs);